import { useState } from 'react';

import { useModal } from '../../hooks';
import { JsonView, Modal } from '../../components';

export const useView = () => {
  const [value, setValue] = useState<object>({});
  const { isOpened, onOpen, onClose } = useModal();

  const handleView = (object: Object) => {
    // alert(JSON.stringify(object, null, 2));
    setValue(object);
    onOpen();
  };
  const handleClose = () => {
    onClose();
    setValue({});
  };

  return {
    element: isOpened && (
      <Modal title="Preview" open={isOpened} onClose={handleClose}>
        <JsonView value={value} />
      </Modal>
    ),
    handleView,
  };
};
